import {UserInfo} from '../types/GaasAppState';

/**
 * @deprecated
 * Refactor useStartTransaction later to use userInfo from AuthContext
 */
export const userInfo = (): UserInfo | null => {
    const info = sessionStorage.getItem('userInfo');

    try {
        return info ? JSON.parse(info) : null;
    } catch (err) {
        console.error(`userInfo data error; ${err}`);
    }

    return null;
};
